"use client";

import { c as _c } from "react/compiler-runtime";
import { Leaf, Trees, Sun, Cloud, Target, Wheat, ArrowRight } from "lucide-react";
import { TENANTS, type TenantId } from "@/lib/tenant";

// Map tenant IDs to their icons
const TENANT_ICONS: Record<TenantId, React.ComponentType<{
  className?: string;
}>> = {
  main: Trees,
  okopunkte: Leaf,
  co2: Cloud,
  jagd: Target,
  energie: Sun,
  acker: Wheat
};

// Specialist tenants to show (excluding main)
const SPECIALIST_TENANTS: TenantId[] = ["okopunkte", "co2", "jagd", "energie", "acker"];
interface PlatformPickerProps {
  className?: string;
}

/**
 * Platform picker component shown on the main hub (euro-pro-flaeche.de)
 * Displays all specialist marketplaces as clickable cards
 */
export function PlatformPicker(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-center mb-6"><h2 className="text-xl font-semibold text-foreground mb-2">Spezialisierte Marktplätze</h2><p className="text-sm text-foreground-muted">Wählen Sie Ihren Fachmarkt für spezialisierte Angebote</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">{SPECIALIST_TENANTS.map(_temp)}</div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <div className={className}>{t1}{t2}</div>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}

/**
 * Compact version for the map sidebar
 */
function _temp(tenantId) {
  const tenant = TENANTS[tenantId];
  const Icon = TENANT_ICONS[tenantId];
  return <a key={tenantId} href={`https://${tenant.domain}`} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 p-4 bg-white rounded-xl border border-surface-dim hover:border-surface-container-highest hover:shadow-md transition-all"><div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105" style={{
      backgroundColor: tenant.theme.primary
    }}><Icon className="w-6 h-6 text-white" /></div><div className="flex-1 min-w-0"><h3 className="font-medium text-foreground group-hover:text-foreground truncate">{tenant.name}</h3><p className="text-xs text-foreground-muted truncate">{tenant.tagline}</p></div><ArrowRight className="w-4 h-4 text-foreground-muted group-hover:text-foreground-muted transition-transform group-hover:translate-x-1" /></a>;
}
export function PlatformPickerCompact(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="px-4 py-3 bg-surface-container-low border-b border-surface-container-low"><h3 className="text-sm font-medium text-foreground">Fachmarktplätze</h3></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-white rounded-lg shadow-lg overflow-hidden">{t1}<div className="p-2 space-y-1">{SPECIALIST_TENANTS.map(_temp2)}</div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <div className={className}>{t2}</div>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp2(tenantId) {
  const tenant = TENANTS[tenantId];
  const Icon = TENANT_ICONS[tenantId];
  return <a key={tenantId} href={`https://${tenant.domain}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-surface-container-low transition-colors group"><div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0" style={{
      backgroundColor: tenant.theme.primary
    }}><Icon className="w-3.5 h-3.5 text-white" /></div><span className="text-sm text-foreground group-hover:text-foreground truncate">{tenant.name}</span></a>;
}